import { useCallback, useLayoutEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";

import { useTooltipAutoClose, useTooltipPortalFade } from "../../lib/useTooltipAutoClose";
import classes from "./GlobalTooltip.module.css";

export default function GlobalTooltip({ children, danger, noMargin }) {
    const triggerRef = useRef(null);
    const tooltipElRef = useRef(null);
    const { isOpen, isVisible, isClosing, open, close } = useTooltipPortalFade();
    const [coordinates, setCoordinates] = useState({
        top: null,
        left: null,
    });

    const updateCoordinates = useCallback(() => {
        if (triggerRef.current) {
            const rect = triggerRef.current.getBoundingClientRect();
            setCoordinates({
                top: rect.top,
                left: rect.left + rect.width / 2,
            });
        }
    }, []);

    useLayoutEffect(() => {
        if (isOpen) {
            updateCoordinates();
        }
    }, [isOpen, updateCoordinates]);

    useTooltipAutoClose({
        isOpen,
        onClose: close,
        triggerRef,
        tooltipRef: tooltipElRef,
        interactive: false,
    });

    function pointerEnterHandler() {
        open();
        updateCoordinates();
    }

    function pointerLeaveHandler() {
        close();
    }

    const overlayRoot = document.getElementById("overlay-root");

    return (
        <div
            className={`${classes.tooltip} ${danger ? classes.danger_tooltip : ""} ${noMargin ? classes.no_margin : ""}`}
            ref={triggerRef}
            onPointerEnter={pointerEnterHandler}
            onPointerLeave={pointerLeaveHandler}
        >
            {!danger && <i className="ti ti-question-mark" />}
            {danger && <i className="ti ti-alert-circle" />}
            {isVisible &&
                overlayRoot &&
                ReactDOM.createPortal(
                    <div
                        ref={tooltipElRef}
                        className={`${classes.tooltip_modal} ${isClosing ? classes.closing : ""}`}
                        style={{ top: coordinates.top, left: coordinates.left }}
                    >
                        {children}
                    </div>,
                    overlayRoot,
                )}
        </div>
    );
}
